import { FromSchema } from '@40seas/entities/common';
import { Invoice, InvoiceSchema } from '@40seas/entities/invoices';
import { z } from 'zod';

export const UploadInvoiceResultSchema = z.object({
    invoice: InvoiceSchema,
    uploadUrl: z.string(),
});

export class UploadInvoiceResult extends FromSchema(UploadInvoiceResultSchema) {
    invoice: Invoice;
    uploadUrl: string;
}
